(ns ycweb.app.website.cart.pages.empty
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cart.model :as model]
   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.app.website.cards :as cards]
   [ycweb.components.common :as cmn]))

(rum/defc empty-cart-message []
  [:div {:class "u-block-center cta-block cta-block--has-error"}
   [:h2 {:class "yc-heading yc-heading--default yc-heading--center"}
    "Your cart is empty…"]
   [:p {:class "yc-paragraph u-text-center"}
    "No problem. Head on over to our homepage to "
    [:a {:href "/index.htm" :class "text-link"} "start shopping again"]
    " or try some products below that we think you might like."]
   [:div {:class "u-block-center u-max-width-320 u-text-center"}
    [:a {:href "/index.htm" :class "button button--large button--raised button--full button--primary"}
     [:span {:class "button__text"} "Start shopping"]]]])

(rum/defc suggested-products-section < rum/reactive
  {:did-mount
   (fn [state]
     ;; Trigger the fetch ourselves so suggestions load however the empty cart is
     ;; reached (reset after removing the last item, fresh load, hard nav). Idempotent —
     ;; fetch-suggested-products no-ops if they're already loaded.
     (model/fetch-suggested-products (first (:rum/args state)))
     state)}
  [app-atom]
  (let [suggested-products-atom (rum/cursor-in app-atom [:suggested-products])
        suggested-products (rum/react suggested-products-atom)

        ;; Transform simplified API response to shape expected by product-card-default
        transformed-products
        (map
          (fn [product]
            {:ent/display-name (:title product)
             :ent/image {:doc/public-id (:image_url product)}
             :product/id (:id product)
             :product/url (:product_url product)
             :product/brand (:brand product)
             :product/name-ex-brand (:title product)
             :product/price (:price product)
             :product/price-was (:price_was product)
             :product/avg-rating (:rating product)
             :product/in-stock "Rush"
             :product/num-reviews 0
             :product/made-in nil
             :product/new? false
             :product/colours []
             :product/features []
             :product/variations []
             :product/stats nil})
          suggested-products)]

    [:div {:class "yc-section yc-section--medium"}
     [:h2 {:class "yc-heading yc-heading--default"}
      "Some products we think you might like…"]
     [:div {:class "flex-grid-group flex-grid-group--small flex-grid-group--align-left"}
      (if (seq transformed-products)
        (for [product transformed-products]
          [:div {:class "flex-grid-block flex-grid-block--small flex-grid-block--t-1-2 flex-grid-block--ml-1-3 flex-grid-block--l-1-6"}
           (try
             (cards/product-card-default app-atom product {:small? true})
             #?(:clj
                (catch Throwable e
                  (println "Error rendering product card:" (pr-str product) " - " e))
                :cljs
                (catch :default e
                  (println "Error rendering product card:" (pr-str product) " - " e))))])

        [:div {:class "u-text-center"} "Loading suggested products..."])]
     [:div {:class "u-margin-top-24 u-text-center u-block-center u-max-width-240"}
      [:a {:href "/index.htm" :class "button button--default button--raised button--full button--secondary button--bordered"}
       [:span {:class "button__text"} "Start shopping"]]]]))

(rum/defc empty-cart-view < rum/reactive cmn/cursors [app-atom process-atom cart-atom]
  [:main {:id "main-content" :class "yc-section"}
   [:div {:class "yc-section yc-section--medium"}
    (empty-cart-message)]
   (suggested-products-section app-atom)])

(defmethod cart.common/checkout-step :cart/empty
  [app-atom process-atom cart-atom]
  (empty-cart-view app-atom process-atom cart-atom))
